import React from 'react';
import { Row, Col } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function BuyNowButton(props) {
  
  let index = props.index;
  let textColor = '#fff';
  let bg1 = props.bgColor;
  let bg2 = props.fontColor;
  let str4 = props.strValue4==='$' ? 'USD' : props.strValue4;
  let str5 = props.strValue5;
  let str3 = props.strValue3 ? props.strValue3 : props.strValue6.split(' ')[0] ;
  let str6 = props.strValue3 ? props.strValue6 : props.strValue6.split(' ')[1] ;

  return (
    <div style={{ cursor: 'pointer', width:'100%', display: 'flex', background: '#eee', borderRadius: '3px' }}>
            <Row style={{ width: 56, margin: 2, background: '#eee',  }}>
                <Col style={{ display: 'flex', alignItems:'center', padding: 4 }} span={24}>
                  <div className='col' style={{ width: '100%' }}>
                    <div style={{ color: bg2, fontSize: '12px', lineHeight: 1.4, textAlign:'center', fontFamily: 'OpenSans-Bold' }}>{str4}</div>
                    <div style={{ color: bg2, fontSize: '18px', lineHeight: 1, textAlign:'center', fontFamily: 'OpenSans-Bold' }}>{str5}</div>
                  </div>
                </Col>
            </Row>
            <Row style={{ width: 160, background: bg2, margin: 2, marginLeft: 0, marginRight: 0 }}>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                  <FontAwesomeIcon icon={props.icon} style={{ color: textColor, fontSize: props.fontIcon, marginRight: 12 }} />
                    <div style={{ color: textColor, fontSize: '18px', lineHeight: 1.1, textAlign:'left', fontFamily: 'OpenSans-Bold' }}>
                      {props.strValue1}
                    </div>
                  </div>
            </Row>
            <Row style={{ width: 56, margin: 2, background: '#eee',  }}>
                <Col style={{ display: 'flex', alignItems:'center', padding: 4 }} span={24}>
                  <div className='col' style={{ width: '100%' }}>
                    <div style={{ color: bg2, fontSize: '11px', textAlign:'center', fontFamily: 'OpenSans-SemiBold' }}>{props.strValue2}</div>
                    <div style={{ color: bg2, fontSize: '18px', lineHeight: 1.1, textAlign:'center', fontFamily: 'OpenSans-Bold' }}>{str6}</div>
                    <div style={{ color: bg2, fontSize: '11px', textAlign:'center', fontFamily: 'OpenSans-SemiBold' }}>{str3}</div>
                  </div>
                </Col>
            </Row>            
    </div>
  );
}
